import React, { memo, useEffect, useState } from 'react';
import { Box } from '@material-ui/core';

import useStyles from './styles';

const CircleChart = props => {
  const classes = useStyles(props);
  const { percentage, className, label, ...otherProps } = props;
  const [percent, setPercentage] = useState(0);

  useEffect(() => {
    const timeoutId = setTimeout(() => setPercentage(percentage));
    return function cleanup() {
      clearTimeout(timeoutId);
    };
  }, [percentage]);

  return (
    <Box className={`${classes.container} ${className}`} {...otherProps}>
      <svg viewBox="0 0 36 36" className="chart-circle">
        <path
          className="chart-circle-bg"
          d="M18 2.0845
            a 15.9155 15.9155 0 0 1 0 31.831
            a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        <path
          className={`chart-circle-fill ${percent !== 0 && 'is-active'} ${
            percent >= 100 && 'concluded'
          }`}
          strokeDasharray={`${percent} 100`}
          d="M18 2.0845
            a 15.9155 15.9155 0 0 1 0 31.831
            a 15.9155 15.9155 0 0 1 0 -31.831"
        />
      </svg>
      <span className={`chart-text ${percent >= 100 && 'material-icons'}`}>
        {percent >= 100 && 'check'}
        {percent < 100 && label && label}
        {percent < 100 && !label && `${percent}%`}
      </span>
    </Box>
  );
};

export default memo(CircleChart);
